import {
    Divider,
    Heading,
    Stack,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { SafeHTML } from "components/safe-html";
import { useLocalizedValue } from "helpers/use-localized-value";
import { Experience } from "types/experience";

interface InformationOnlyExperienceProps {
    experience: Experience;
    isFirstExperience: boolean;
}

function InformationOnlyExperience({
    experience,
    isFirstExperience,
}: InformationOnlyExperienceProps) {
    const experienceName = useLocalizedValue(experience.name);
    const experienceDescription = useLocalizedValue(experience.description);

    return (
        <Stack
            spacing={ThemeSpaceVariable.Small}
            mt={isFirstExperience ? ThemeSpaceVariable.Medium : ThemeSpaceVariable.None}
            pb={ThemeSpaceVariable.Large}
            data-experience-id={experience.id}
        >
            <Heading
                as="h3"
                fontSize={ThemeFontSizeVariable.Large}
                color={ThemeColorVariable.OnBackgroundHeader}
                fontWeight={"medium"}
            >
                {experienceName}
            </Heading>
            {experienceDescription && (
                <Text
                    fontSize={ThemeFontSizeVariable.Medium}
                    color={ThemeColorVariable.OnSurfaceSubdued}
                >
                    <SafeHTML element="span" html={experienceDescription} />
                </Text>
            )}
            <Divider mt={ThemeSpaceVariable.Medium} />
        </Stack>
    );
}

export default InformationOnlyExperience;
